/**
 * CelebRoomPersonaGate — wraps Celeb Room routes that require an active persona.
 *
 * The Celeb Room feature reuses the shared DM persona (a signed-in user JWT).
 * If no persona is set, redirects to the existing persona login page (/dm/users)
 * with a redirect param back to the requested Celeb Room path.
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useDmPersona } from '../context/DmPersonaContext';

export default function CelebRoomPersonaGate({ children }) {
  const { isAuthenticated, loading } = useDmPersona();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[200px]">
        <span className="text-dark-text-secondary text-sm">Loading...</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    const redirectTo = location.pathname + location.search;
    return (
      <Navigate
        to={`/dm/users?redirect=${encodeURIComponent(redirectTo)}`}
        replace
      />
    );
  }

  return children;
}
